import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard/Dashboard'
import DoubtView from '@/components/Dashboard/DoubtView'
import DashboardOverview from '@/components/Dashboard/Overview'
import DashboardAddDoubt from '@/components/Dashboard/AddDoubt'
import Solutions from '@/components/Dashboard/Solutions'
import History from '@/components/Dashboard/History'
import DoubtsAll from '@/components/Dashboard/DoubtsAll'
import Packages from '@/components/Dashboard/Packages'
import PackagesHistory from '@/components/Dashboard/PackagesHistory'
import AssignedDoubts from '@/components/Dashboard/AssignedDoubts'
import UnsolvedDoubts from '@/components/Dashboard/UnsolvedDoubts'
import Transactions from '@/components/Dashboard/Transactions'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },{
    	path: '/login',
    	name: 'Login',
    	component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          path:'doubts-all',
          component:DoubtsAll
        },
        {
          path:'add-doubt',
          component:DashboardAddDoubt
        },{
          path:'solutions',
          component:Solutions
        },{
          path:'history',
          component:History
        },{
          path:'packages',
          component:Packages
        },{
          path:'packages-history',
          component:PackagesHistory
        },{
          path:'doubts/:id',
          component:DoubtView
        },{
          path:'assigned',
          component: AssignedDoubts
        },
        {
          path:'unsolved',
          component: UnsolvedDoubts
        },
        {
          path:'transactions',
          component: Transactions
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js